import React from 'react'

import { Bullet, BulletsBox } from './Navigation/styles'
import { Slide } from './Slide'
import { useHomepageSlides } from './query'
import { Box, Slides } from './styles'
import { useCarousel } from './useCarousel'

export function Slider() {
  const { slides } = useHomepageSlides()
  const { ref, bullets, onBulletClick, selectedIndex } = useCarousel()

  return (
    <Box ref={ref}>
      <Slides>
        {slides?.map((slide) => (
          <Slide
            key={slide.id}
            slide={slide}
          />
        ))}
      </Slides>

      <BulletsBox>
        {bullets.map((_, index) => (
          <Bullet
            key={index}
            selected={index === selectedIndex}
            onClick={() => onBulletClick(index)}
          />
        ))}
      </BulletsBox>
    </Box>
  )
}
